/*
 * Force the accented Spanish label on the Klaviyo "Back in Stock" button.
 * Klaviyo injects #klaviyo-bis-button-container with the label configured in the
 * Klaviyo account, which does not keep the accents. We override it on the
 * storefront so it reads "Avísame cuando esté disponible".
 */
(function () {
  var DESIRED = 'Avísame cuando esté disponible';

  function setText(el) {
    // Walk down to the innermost element that holds only this text.
    var target = el;
    while (
      target.children &&
      target.children.length === 1 &&
      target.children[0].textContent === target.textContent
    ) {
      target = target.children[0];
    }
    if (target.textContent !== DESIRED) {
      target.textContent = DESIRED;
    }
  }

  function fix() {
    var container = document.getElementById('klaviyo-bis-button-container');
    if (!container) return;
    // Only touch the actual button — never the container itself, or we would
    // inject a stray text node next to Klaviyo's button.
    var btn = container.querySelector('button');
    if (btn && btn.textContent.trim() !== DESIRED) {
      setText(btn);
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      fix();
    });
  }

  function start() {
    fix();
    // Klaviyo injects the button and then sets its label asynchronously (as a
    // text/characterData change), so watch childList + characterData.
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });
    // Safety net: retry for the first few seconds in case the widget loads late.
    var tries = 0;
    var timer = setInterval(function () {
      fix();
      if (++tries >= 40) clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
